"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrialRecord = void 0;
const RecordApi_1 = require("../../apis/RecordApi");
const usePullRefresh_1 = require("../../hooks/usePullRefresh");
const rxjs_1 = require("rxjs");
const defaultPageLength = 10;
/**查询体验金记录 */
function useTrialRecord(props) {
    const { filterParams, limit = defaultPageLength } = props;
    return (0, usePullRefresh_1.usePullRefreshV2)({
        query: (params) => {
            var _a;
            const nLimit = (_a = filterParams === null || filterParams === void 0 ? void 0 : filterParams.limit) !== null && _a !== void 0 ? _a : limit;
            return (0, RecordApi_1.queryTrialHistory)(Object.assign(Object.assign(Object.assign({}, params), { limit: nLimit }), filterParams)).pipe((0, rxjs_1.map)((list) => {
                var _a;
                return {
                    data: list,
                    hasMore: list.length === nLimit,
                    params: {
                        end_time: (_a = list[list.length - 1]) === null || _a === void 0 ? void 0 : _a.create_time,
                        limit: nLimit,
                    },
                };
            }));
        },
    });
}
exports.useTrialRecord = useTrialRecord;
